module.exports = __webpack_public_path__ + "static/media/MY-Um.3010fdb6.png";